<tt-page *ngIf="!!inputListLanguages">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <div *ngFor="let item of inputListLanguages">
            <tt-input [ttLabel]="item.language_name" [(ttModel)]="item.listdatalang_name"></tt-input>
            <tt-textarea ttLabel="listdatalang_description" [(ttModel)]="item.listdatalang_description"></tt-textarea>
        </div>

        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
